

try {
  window.addEventListener('load', (event) => {
    // Shopify/Liquid/Bold/API Options Variables
    let __liquidTag;
    let __productTag;
    let __productTitle;
    let __useFree = false;
    let __isPackage = false;
    let __isGroup = false;
    let __isSpecialGroup = false;
    let __isSigmaIotaAlpha = false;
    let __enablePopupBeforePageLeave = false;
    let __useSavedData = false;
    let __defaultLetters = [];
    let __productStyle = [];
    const __letterGeneratorContainer = document.querySelector('.letter-generator');
    const __updateLabels = document.querySelectorAll('.update-label');
    const apiData = {
      patterns: '',
      borders: '',
      garments: [],
      letters: '',
      sizes: [],
    };
    const apiLoaded = {
      patterns: 0,
      borders: 0,
      garments: [0, 0],
      letters: 0,
      sizes: 0,
    };
    const bold = {
      letter: [],
      pattern: [],
      border: [],
      garment: [],
      size: [],
    };


    // 'Active' States && Product Selection Info
    let activeLetter = 0;
    let activeDropdown = 0;
    let activeProduct = 1;
    let activePatternImg = '';
    let activeBorderImg = '';
    let activeGarmentImg = '';
    let activePatternName = '';
    let activeBorderName = '';
    let activeGarmentName = '';
    let activeSizeName = '';
    
    const savedProducts = [
      {
        key: 1,
        patternImg: 'https://something-greek.s3.amazonaws.com/LE020.png',
        borderImg: 'https://something-greek.s3.amazonaws.com/NavyBd.jpg',
        garmentImg: '',
        patternName: 'Pattern CC4014 + $2.95',
        borderName: 'Gold + $3.95',
        garmentName: '',
      },
      {
        key: 2,
        patternImg: 'https://something-greek.s3.amazonaws.com/TurquoiseBd.jpg',
        borderImg: 'https://something-greek.s3.amazonaws.com/PINK.jpg',
        garmentImg: '',
        patternName: 'Pink',
        borderName: 'Turquoise + $3.95',
        garmentName: '',
      }
    ];


    // SVG Data for Greek Letters
    const letters = JSON.parse(document.getElementById('ltrgen-letters').textContent);
    const borders = JSON.parse(document.getElementById('ltrgen-borders').textContent);




    // Prep
    function parseShopifyTag() {
      const productTitleDOM = document.getElementById('product-title');

      __metafields = productTitleDOM.dataset.greekMetafieldSaved;
      __sessionStorageKeys = {
        greek1: 'ltrgen-greek-1',
        greek2: 'ltrgen-greek-2',
        greek3: 'ltrgen-greek-3'
      };
      __productTitle = productTitleDOM.textContent;
      __liquidTag = productTitleDOM.dataset.liquid;
      __productTag = __liquidTag.split('-');
      __productTag.shift();

      if (__productTitle.includes('Pack')) {
        __isPackage = true;
        if (__productTag[__productTag.length - 1] === 'package') __productTag.pop();
        __productStyle[1] = __productTag.pop();
        __productStyle[0] = __productTag.pop();
        replaceProductLabelsAboveGenerator(__productStyle);
      } else {
        __productStyle[0] = __productTag.pop();

      }


      if (__productTag[0] === 'main') {
        __defaultLetters = ['beta', 'alpha', 'epsilon'];

      } else if (__productTag[0] === 'sor') {
        __defaultLetters = ['delta', 'phi', 'epsilon'];

      } else if (__productTag[0] === 'frat') {
        __defaultLetters = ['tau', 'kappa', 'epsilon'];

      } else if (__productTag[0] === 'sigmaalphaepsilonpi') {
        __defaultLetters = ['sigma alpha epsilon pi', '*not applicable', '*not applicable'];
        __isGroup = true;
        __isSpecialGroup = true;

      } else if (__productTag[0] === 'fiji') {
       __defaultLetters = ['fiji letters', '*not applicable', '*not applicable'];
       __isGroup = true;
       __isSpecialGroup = true;
      
      } else {
        let letter1 = __productTag.shift();
        let letter2 = __productTag.shift();
        let letter3 = __productTag[2] !== __productTag[__productTag.length - 1] ? __productTag.shift() : '*not applicable';
        __defaultLetters = [letter1, letter2, letter3];
        __isGroup = true;

        if (__defaultLetters.join(' ') == 'sigma iota alpha') {
          __isSigmaIotaAlpha = true;
          console.log('__isSigmaIotaAlpha');
        }
      }

      // Overwrite with saved values via metafields or sessionStorage)
      if (!__isGroup && !__isSpecialGroup) {
        if (__metafields === 'true') {
          __defaultLetters = [
            productTitleDom.dataset.greek1,
            productTitleDom.dataset.greek2,
            productTitleDom.dataset.greek3
          ];
          __useSavedData = true;
        
        } else if (sessionStorage.getItem(__sessionStorageKeys.greek1)) {
          __defaultLetters = [
            sessionStorage.getItem(__sessionStorageKeys.greek1),
            sessionStorage.getItem(__sessionStorageKeys.greek2),
            sessionStorage.getItem(__sessionStorageKeys.greek3)
          ];
          __useSavedData = true;
        }
      }

      if (__defaultLetters[0] === 'sigma alpha epsilon pi' || __defaultLetters[0] == 'fiji letters') {
        __isSpecialGroup = true;
      }
    }


    function boldSetup() {
      if (document.querySelector('.bold_option_set')) {
        const options = document.querySelectorAll('.bold_option');


        options.forEach((option) => {
          const optionName = option.querySelector('.bold_option_title');
          const optionValue = option.querySelector('.bold_option_element > select');
          if (!__isGroup) {
            if (optionName.innerHTML.indexOf('1st Greek Letter') !== -1) {
              bold.letter[0] = optionValue;

            } else if (optionName.innerHTML.indexOf('2nd Greek Letter') !== -1) {
              bold.letter[1] = optionValue;

            } else if (optionName.innerHTML.indexOf('3rd Greek Letter') !== -1) {
              bold.letter[2] = optionValue;

            }
          }

          if (!__isPackage) {
            if (optionName.innerHTML.indexOf('Letter Color / Pattern') !== -1) {
              bold.pattern[0] = optionValue;
              __useFree = optionValue[100].value.indexOf('$') === -1 ? true : false;

            } else if (optionName.innerHTML.indexOf('Border Color') !== -1) {
              bold.border[0] = optionValue;

            } else if ((optionName.innerHTML.indexOf('Color') !== -1) && (optionName.innerHTML.indexOf('Border Color') === -1) && (optionName.innerHTML.indexOf('Letter Color') === -1) && (optionName.innerHTML.indexOf('Lace') === -1)) {
              bold.garment[0] = optionValue;
            }
          } else {
            if (optionName.innerHTML.indexOf('Letter Color / Pattern #2') !== -1) {
              bold.pattern[1] = optionValue;

            } else if (optionName.innerHTML.indexOf('Border Color #2') !== -1) {
              bold.border[1] = optionValue;

            } else if ((optionName.innerHTML.indexOf('Color') !== -1) && (optionName.innerHTML.indexOf('Border') === -1) && (optionName.innerHTML.indexOf('Letter') === -1) && (optionName.innerHTML.indexOf('Lace') === -1) && (!option.classList.contains('first')) && (optionName.innerHTML.indexOf('1') === -1)) {
              bold.garment[1] = optionValue;

            } else if ((optionName.innerHTML.indexOf('Size #2') !== -1)) { 
              apiData.sizes[1] = boldConvertOptionsToObjectArray(optionValue);
              bold.size[1] = optionValue;

            } else if ((optionName.innerHTML.indexOf('Letter Color / Pattern') !== -1) && (optionName.innerHTML.indexOf('#2') === -1)) {
              bold.pattern[0] = optionValue;
              _useFree = optionValue[100].value.indexOf('$') === -1 ? true : false;

            } else if ((optionName.innerHTML.indexOf('Border Color') !== -1) && (optionName.innerHTML.indexOf('#2') === -1)) {
              bold.border[0] = optionValue;

            } else if ((optionName.innerHTML.indexOf('Color') !== -1) && (optionName.innerHTML.indexOf('Border') === -1) && (optionName.innerHTML.indexOf('Letter') === -1) && (optionName.innerHTML.indexOf('Lace') === -1) && (option.classList.contains('first') || optionName.innerHTML.indexOf('2') === -1)) {
              bold.garment[0] = optionValue;
            
            } else if ((optionName.innerHTML.indexOf('Size') !== -1) && (optionName.innerHTML.indexOf('2') === -1)) {
              apiData.sizes[0] = boldConvertOptionsToObjectArray(optionValue);
              bold.size[0] = optionValue;
            }
          }
        });
          
        


        initSelectLetter();
        initLetters();
        initClickSelectProduct();
        initDropdowns();
      } else {
        setTimeout(boldSetup, 100);
      }
    }

    function boldConvertOptionsToObjectArray(arr) {
      const sizeOptions = [...arr.children].filter(ele => ele.value != '');
      if (sizeOptions.length === 0) return;
      
      const res = sizeOptions.map((ele) => {
        return {
          title: ele.value,
          price: ele.dataset.price || '0',
        }
      });

      return res;
    }

    async function apiGet(key, loadPackage) {
      let url = '';
      const tagID = loadPackage === true ? __productStyle[1] : __productStyle[0];

      switch (key) {
        case 1:
          url = '//something-greek.herokuapp.com/patterns/get';
          break;
        case 2:
          url = '//something-greek.herokuapp.com/borders/get';
          break;
        case 3:
          url = '//something-greek.herokuapp.com/backgrounds/get?' + new URLSearchParams({ tag_id: tagID });

          break;
        case 4:
          url = '//something-greek.herokuapp.com/letters/get';
          break;
      }

      try {
        let res = await fetch(url);
        return await res.json();
      } catch (error) {
        console.log(error);
      }
    }

    async function prepareAPIData() {
      apiData.patterns = await apiGet(1);
      apiData.borders = await apiGet(2);
      apiData.garments[0] = await apiGet(3);
      __isPackage === true && (apiData.garments[1] = await apiGet(3, __isPackage));
      apiData.letters = await apiGet(4);
    }






    // Initialize

    function renderOptions(key, loadPackage) {
      let keyName;
      let options;
      let beginLoop;
      let endLoop;
      let loadBatchSize = 0;
      let optionContainer;
      let num = loadPackage ? 1 : 0;
      let useApiData = true;

      switch (key) {
        case 1:
          keyName = 'patterns';
          options = apiData.patterns;
          beginLoop = apiLoaded.patterns;
          optionContainer = document.querySelector('.pattern-list');
          loadBatchSize = 60;
          break;
        case 2:
          keyName = 'borders';
          options = apiData.borders;
          beginLoop = apiLoaded.borders;
          optionContainer = document.querySelector('.border-list');
          loadBatchSize = 12;
          break;
        case 3:
          keyName = 'garments';
          options = apiData.garments[num];
          beginLoop = apiLoaded.garments[num];
          optionContainer = document.querySelector(`.garment-list-${num + 1}`);
          loadBatchSize = 12;
          break;
        case 4:
          keyName = 'letters';
          options = apiData.letters;
          beginLoop = apiLoaded.letters;
          optionContainer = document.querySelector('.letter-list');
          loadBatchSize = 24;
          break;
        case 5:
          keyName = 'sizes';
          options = apiData.sizes[num];
          beginLoop = 0;
          optionContainer = document.querySelector(`.size-list-${num + 1}`);
          loadBatchSize = options.length;
          useApiData = false;
          break;
      };

      if (useApiData === true) {
        generateElements();
        loadPackage ? lazyScroll(key, keyName, loadPackage) : lazyScroll(key, keyName);
      } else {
        generateSizeElements();
      }

      function generateSizeElements() {
        const fragment = new DocumentFragment();
        const endLoop = beginLoop + loadBatchSize > options.length ? options.length : beginLoop + loadBatchSize;

        for (let i = beginLoop; i < endLoop; i++) {
          const sizeElement = createSizeElement(keyName, key, options[i], num);
          sizeElement && fragment.append(sizeElement);
        }

        optionContainer.append(fragment);

        function createSizeElement(keyName, key, option, num) {
          const _li = document.createElement('li');
          const _a = document.createElement('a');

          _li.setAttribute('class', `item-${option.title}__${num}`);
          _li.setAttribute('id', `aria-${option.title}__${num}`);
          _li.setAttribute('aria-label', `${option.title}`);

          _a.setAttribute('class', `choose-${keyName} ${keyName}-${option.title}`);
          _a.setAttribute('data-id', `${option.title}__${num}`);
          _a.setAttribute('data-target', `${option.title}`);
          _a.setAttribute('aria-labelledby', `aria-${option.title}__${num}`);
          _a.setAttribute('data-active-product', `${num}`);

          _a.addEventListener('click', function(e) {
            updateGenerator(key, _a);
          });


          _a.textContent = option.title;
          _li.append(_a);

          return _li;
        }
      }


      function generateElements() {
        /*
          Note: Checking for key === 1 || 2 is due to Bold Options
                Makes sure that price upcharge is shown, if applicable
        */
        const fragment = new DocumentFragment();
        const endLoop = beginLoop + loadBatchSize > options.length ? options.length : beginLoop + loadBatchSize;
        let boldOptions;

        if (key === 2) {
          boldOptions = [...bold.border[0].querySelectorAll('.bold_option_element > select > option')];
        }

        for (let i = beginLoop; i < endLoop; i++) {
          const listElement = createListElement(keyName, key, options[i]);
          
          if (key === 2) {
            // get price from bold options using textContent from figcaption
            const swatchTitle = listElement.querySelector('figcaption');
            const currentBoldOption = boldOptions.filter((ele) => ele.textContent.includes(swatchTitle.textContent));

            if (currentBoldOption.length > 0) {
              swatchTitle.innerHTML = currentBoldOption[0].textContent.replace('[', '<br>[');
            }
          }
          
          listElement && fragment.append(listElement);
        }

        key === 3 ? (apiLoaded[keyName][num] = endLoop) : (apiLoaded[keyName] = endLoop);
        optionContainer.append(fragment);
      }

      function createListElement(keyName, key, option) {
        const optionTarget = () => {
          if (key === 3) return option.target;
          if (key === 4) return option.label;
          if (__useFree) return option.target2;
          return option.target;
        };
        const optionID = key === 3 ? option._id : option.id;

        const _li = document.createElement('li');
        _li.setAttribute('class', `item-${optionID}`);
        _li.setAttribute('id', `aria-${optionID}`);
        _li.setAttribute('aria-label', `${optionTarget()}`);

        const _a = document.createElement('a');
        _a.setAttribute('class', `choose-${keyName} ${keyName}-${optionID}`);
        _a.setAttribute('data-id', `${optionID}`);
        _a.setAttribute('data-file', `${option.file}`);
        _a.setAttribute('data-target', `${optionTarget()}`);
        _a.setAttribute('aria-labelledby', `aria-${optionID}`);

        if (option.file2 || option.file3) {
          [option.file2, option.file3].forEach((optionFile, i) => {
            if (optionFile != option.file1) {
              _a.setAttribute(`data-file${i+2}`, optionFile);
            }
          }); 
        }
        
        _a.addEventListener('click', function(e) {
          updateGenerator(key, _a);
        });

        const _figure = document.createElement('figure');
        const _img = document.createElement('img');
        _img.setAttribute('src', `${option.file}`);
        _img.setAttribute('width', 180);
        _img.setAttribute('height', 180);
        _img.setAttribute('alt', `${optionTarget()}`);
        _img.setAttribute('loading', 'lazy');

        const _figcaption = document.createElement('figcaption');
        _figcaption.setAttribute('aria-labelledby', `aria-${optionID}`);
        _figcaption.innerHTML = optionTarget().replace(/ \+ \$/, `<br/>+ $`);

        _figure.append(_img);
        _figure.append(_figcaption);
        _a.append(_figure);
        _li.append(_a);

        return _li;
      }

    };



    function lazyScroll(key, keyName, loadPackage) {
      let list;
      let num = loadPackage ? 1 : 0;


      switch (key) {
        case 1:
          list = document.querySelector('.pattern-list');
          break;
        case 2:
          list = document.querySelector('.border-list');
          break;
        case 3:
          list = document.querySelector(`.garment-list-${num + 1}`);
          break;
        case 4:
          list = document.querySelector('.letter-list');
      }

      list.addEventListener('scroll', infinityScroll);


      function infinityScroll() {
        let currLoad;
        let currData;

        if (key === 3) {
          currLoad = apiLoaded[keyName][num];
          currData = apiData[keyName][num].length;
        } else {
          currLoad = apiLoaded[keyName];
          currData = apiData[keyName].length;
        }

        if (list.offsetHeight + list.scrollTop >= list.scrollHeight - 200) {
          if (currLoad === currData) {
            list.removeEventListener('scroll', infinityScroll);
          } else {
            loadPackage ? renderOptions(key, loadPackage) : renderOptions(key);
          }
        }
      }
    }



    function initDropdowns() {
      const dropdowns = document.querySelectorAll('.manual-drop');

      dropdowns.forEach((dropdown) => {
        const link = dropdown.querySelector('div > a');


        link.addEventListener('click', function (e) {
          e.preventDefault();
          const toSlide = () => {
            if (__isPackage) {
              if (dropdown.classList.contains('garment-options')) {
                return dropdown.querySelector(`.garment-list-${activeProduct}`);
              } else if (dropdown.classList.contains('size-options')) {
                return dropdown.querySelector(`.size-list-${activeProduct}`);
              }
            }

            return dropdown.querySelector('ul');
          };
          const dropdownNum = parseInt(toSlide().dataset.num);

          if (activeDropdown === 0 || activeDropdown === dropdownNum) {
            activeDropdown = activeDropdown === 0 ? dropdownNum : 0;

          } else if (activeDropdown === 4) {
            const currActive = document.querySelector('.active');
            currActive.classList.remove('active');
            slideLetters();
            activeLetter = 0;
            activeDropdown = dropdownNum;

          } else {
            const openDropdown = document.querySelector('.options-dd__open');
            slideDropdown(openDropdown);
            activeDropdown = dropdownNum;
          }

          slideDropdown(toSlide());
        });
      });
    }

    function initClickSelectProduct() {
      if (!__isPackage) return;

      const switchProductNav = document.querySelector('.switch-products');
      const selectProduct = switchProductNav.querySelectorAll('button');
      switchProductNav.classList.add('switch-products__show');

      selectProduct.forEach((select) => {

        select.addEventListener('click', function (e) {
          e.preventDefault();

          const productNum = parseInt(select.dataset.product);
          productNum !== activeProduct && switchActiveProduct();

          const activeBtn = document.querySelector('.switch-products > .active-product');
          activeBtn.classList.remove('active-product');
          select.classList.add('active-product');
        });

      });

    }

    function initLetters() {
      const greekLetters = __defaultLetters;

      if (!__isSpecialGroup) {
        greekLetters.forEach((letter, i) => {
          setLetter(i + 1, letter);
          (!__isGroup) && boldUpdate('letter', i + 1, letter);
        });
      } else {
        let groupName = greekLetters.join(' ').replaceAll(' *not applicable', '');

        console.log(groupName);
        
        if (greekLetters[0] === 'fiji letters' || greekLetters[0] === 'sigma alpha epsilon pi') {
          groupName = greekLetters[0];
        }

        setLetterWithFourth(groupName)

        if (!__isGroup) {
          boldUpdate('letter', 1, groupName);
          boldUpdate('letter', 2, '*not applicable');
          boldUpdate('letter', 3, '*not applicable');
        }
      }
      
      loadSettings(0);
    }

    

    function initSelectLetter() {
      const selectLetters = document.querySelectorAll('.select-letter');

      if (__isGroup) {
        selectDisable();
      } else {
        selectEnable();
      }

      function selectEnable() {
        selectLetters.forEach((select) => {
          const link = document.createElement('a');
          const dataNum = parseInt(select.dataset.num);


          link.addEventListener('click', function (e) {
            e.preventDefault();

            if (activeDropdown === 0) {
              select.classList.add('active');
              slideLetters();
              activeLetter = dataNum;
              activeDropdown = 4;

            } else if (activeDropdown === 4) {
              if (activeLetter === dataNum) {
                select.classList.remove('active');
                slideLetters();
                activeLetter = 0;
                activeDropdown = 0;

              } else {
                const prevActive = document.querySelector('.select-letter.active');
                prevActive.classList.remove('active');
                select.classList.add('active');
                activeLetter = dataNum;

              }

            } else {
              const openDropdown = document.querySelector('.options-dd__open');
              select.classList.add('active');
              slideDropdown(openDropdown);
              slideLetters();
              activeLetter = dataNum;
              activeDropdown = 4;
            }
          });


          if (__isSpecialGroup && dataNum != 1) {
            select.classList.add('hide');
          }
          
          link.innerHTML = 'Select Letter';
          select.append(link);
        });
      }

      function selectDisable() {
        for (let i = 0; i < __defaultLetters.length; i++) {
          if (__defaultLetters[i] !== '*not applicable') {
            selectLetters[i].innerHTML = `<strong>${__defaultLetters[i].charAt(0).toUpperCase() + __defaultLetters[i].slice(1)}</strong>`; 
            (__isGroup || __isSpecialGroup) && selectLetters[i].classList.add('is-group');

          } else if ((!__isSpecialGroup) && (__defaultLetters[i] === '*not applicable' && i === 2)) {
            document.querySelector('.output__letters-list > li:last-child').style.display = 'none';
            document.getElementById('ltrgen-greek-3').remove();
            document.getElementById('ltrgen-greek-4').remove();
            __defaultLetters.pop();
          }
        }

      }

    }



    // Functionality

    function setLetter(num, letter) {
      const letterPaths = [document.querySelector(`#letter-${num} > path`), document.querySelector(`#letter-${num}`)];
      const borderPaths = [document.querySelector(`#border-${num} > path`), document.querySelector(`#border-${num}`)];
      const greekLetter = letter.replace('*not applicable', 'none').replace(/ - ram's head/, 'Rams');

      letterPaths[0].setAttribute('d', letters[greekLetter].path);
      letterPaths[1].setAttribute('transform', letters[greekLetter].offset);
      letterPaths[1].setAttribute('data-greek', greekLetter);

      borderPaths[0].setAttribute('d', borders[greekLetter].path);
      borderPaths[1].setAttribute('transform', borders[greekLetter].offset);
      borderPaths[1].setAttribute('data-greek', greekLetter);

      updateSVG(num);
      
      if (!__isSpecialGroup) {
        handleSessionStorage(num, letter);
      
      } else if (letter.includes('fiji')) {
        handleSessionStorage(1, 'fiji letters');
      }
      

      function handleSessionStorage(num, letter) {
        if (num === 4) return;
        const sessionID = 'ltrgen-greek-' + num;
        const sessionValue = letter;
        sessionStorage.setItem(sessionID, sessionValue)
      }
    }

    function setLetterWithFourth(groupName) {
      let setFinalStorage = false;
      let sanitizedLetters;
      
      if (groupName == 'sigma alpha epsilon pi') {
        sanitizedLetters = ['sigma', 'alpha', 'epsilon', 'pi'];
        setFinalStorage = true;
        
      } else if (groupName == 'fiji letters') {
        sanitizedLetters = ['fiji_f', 'fiji_i', 'fiji_j', 'fiji_i'];
        setFinalStorage = true;
      }

      if (setFinalStorage === true) {
        sanitizedLetters.forEach((letter, i) => setLetter(i + 1, letter));
        sessionStorage.setItem('ltrgen-greek-1', groupName);
        sessionStorage.setItem('ltrgen-greek-2', '*not applicable');
        sessionStorage.setItem('ltrgen-greek-3', '*not applicable');
        specialGroupFuncs('show'); 
      }
    }
    

    function saveSettings(index) {
      savedProducts[index].patternImg = activePatternImg;
      savedProducts[index].borderImg = activeBorderImg;
      savedProducts[index].garmentImg = activeGarmentImg;
    }

    function loadSettings(index) {
      const patterns = document.querySelectorAll('.pattern-image');
      const borders = document.querySelectorAll('.border-image');
      const garment = document.querySelector('.garment-image');
      activePatternImg = savedProducts[index].patternImg;
      activeBorderImg = savedProducts[index].borderImg;
      activeGarmentImg = savedProducts[index].garmentImg;
      activePatternName = savedProducts[index].patternName;
      activeBorderName = savedProducts[index].borderName;
      activeGarmentName = savedProducts[index].garmentName;

      patterns.forEach((pattern) => pattern.setAttribute('href', activePatternImg));
      borders.forEach((border) => border.setAttribute('href', activeBorderImg));
      garment.style.backgroundImage = `url('${activeGarmentImg}')`;

      updateSVG();
    }

    function resetOptions() {
      if (activeDropdown === 4) {
        const activeSelect = document.querySelector('.select-letter.active');
        activeSelect.classList.remove('active');
        slideLetters();
      } else if (activeDropdown !== 0) {
        const openDropdown = document.querySelector('.options-dd__open');
        slideDropdown(openDropdown);
      }

      activeLetter = 0;
      activeDropdown = 0;
    };

    function switchActiveProduct() {
      let currentProductIndex;
      let savedProductIndex;

      if (activeProduct === 1) {
        currentProductIndex = 0;
        savedProductIndex = 1;
        activeProduct = 2;
      } else {
        currentProductIndex = 1;
        savedProductIndex = 0;
        activeProduct = 1;
      }

      saveSettings(currentProductIndex);
      loadSettings(savedProductIndex);
      labelSettings(savedProductIndex);
      resetOptions();
    }

    function labelSettings(activeIndex) {
      __letterGeneratorContainer.dataset.active = activeIndex;
      const index = parseInt(activeIndex);

      const updateLabel = document.querySelectorAll('.update-label');
      if (!updateLabel.length === 0) return;

      updateLabel.forEach((label) => label.textContent = label.getAttribute(`data-label${index}`));
    }

    function handleUpdateSize(key, link) {
      const openDropDown = document.querySelector('.options-dd__open');
      if (key === 5) {
        updateLabel(5, link.dataset.target);
        boldUpdate('size');
        saveSettings(activeProduct - 1);
        openDropDown.classList.remove('options-dd__open');
        activeLetter = 0;
        activeDropdown = 0;
      }
    }

    function updateLabel(key, value) {
      if (value === "") return;
      let labelClass;

      switch (key) {
        case 1:
          labelClass = 'update-label__pattern';
          activePatternName = value;
          break;
        case 2:
          labelClass = 'update-label__border';
          activeBorderName = value;
          break;
        case 3:
          labelClass = 'update-label__garment';
          activeGarmentName = value;
          break;
        case 5:
          labelClass = 'update-label__size';
          activeSizeName = value;
          break;
        default:
          return;
      }
      
      const updateLabel = [...__updateLabels].filter((ele) => ele.classList.contains(labelClass));
      if (!updateLabel || updateLabel.length === 0) return;
      
      updateLabel[0].textContent = value;
      updateLabel[0].setAttribute(`data-label${activeProduct - 1}`, value);
    }


    function updateGenerator(key, link) {
      let output;
      const openDropDown = document.querySelector('.options-dd__open');
      const pattern = document.querySelectorAll('.pattern-image');
      const border = document.querySelectorAll('.border-image');

      if (key === 1) {
        output = document.querySelectorAll('.pattern-image');
        if ((link.dataset.file2 && link.dataset.file2 != link.dataset.file) || (link.dataset.file3 && link.dataset.file3 != link.dataset.file)) {
          console.log('different files');
          output.forEach((patternImg, i) => {
            const fileName = (i === 0) ? 'file' : (!__isSpecialGroup) ? `file${i+1}` : `file3`;
            patternImg.setAttribute('href', link.dataset[fileName]);
            console.log(link.dataset[fileName]);
          });
        } else {
          output.forEach((patternImg) => patternImg.setAttribute('href', link.dataset.file));
        }
        
        openDropDown && openDropDown.classList.remove('options-dd__open');
        activePatternImg = link.dataset.file;
        activePatternName = link.dataset.target;
        updateLabel(key, link.dataset.target);
        boldUpdate('pattern');
        updateSVG();

      } else if (key === 2) {
        const fileLink = link.dataset.target === '*Not Applicable' ? 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=' : link.dataset.file;
        output = document.querySelectorAll('.border-image')
        output.forEach((borderImg) => borderImg.setAttribute('href', fileLink));
        openDropDown && openDropDown.classList.remove('options-dd__open');
        activeBorderImg = fileLink;
        activeBorderName = link.dataset.target;
        updateLabel(key, link.dataset.target);
        boldUpdate('border');
        updateSVG();

      } else if (key === 3) {
        output = document.querySelector('.garment-image');
        output.style.backgroundImage = `url('${link.dataset.file}')`;
        openDropDown && openDropDown.classList.remove('options-dd__open');
        activeGarmentImg = link.dataset.file;
        activeGarmentName = link.dataset.target;
        updateLabel(key, link.dataset.target);
        boldUpdate('garment');
        updateSVG();

      } else if (key === 4) {
        output = document.querySelector('.select-letter.active');
        output && output.classList.remove('active');
        slideLetters();
        
        const groupName = link.dataset.target.toLowerCase();
        const notApplicable = '*not applicable';
        
        
        if (groupName === 'sigma alpha epsilon pi' || groupName == 'fiji letters') {
          setLetterWithFourth(groupName);
          boldUpdate('letter', 1, groupName);
          boldUpdate('letter', 2, notApplicable);
          boldUpdate('letter', 3, notApplicable);
          
        } else if (activeLetter === 1 && __isSpecialGroup) {
            specialGroupFuncs('hide');
            
            if (groupName !== notApplicable) {
              setLetter(1, groupName);
              boldUpdate('letter', 1, groupName);
            }

            setLetter(2, notApplicable);
            setLetter(3, notApplicable);
            boldUpdate('letter', 2, notApplicable);
            boldUpdate('letter', 3, notApplicable);
          
        } else if (activeLetter === 1 && groupName === notApplicable) {
          // do nothing
        } else {
          setLetter(activeLetter, groupName);
          boldUpdate('letter', activeLetter, groupName);
        }
        updateSVG();
        
      } else if (key === 5) {
        updateLabel(key, link.dataset.target);
        boldUpdate('size');
        saveSettings(activeProduct - 1);
        openDropDown.classList.remove('options-dd__open');
      }

      
      saveSettings(activeProduct - 1);
      activeLetter = 0;
      activeDropdown = 0;

      if (__enablePopupBeforePageLeave === false) {
        initPopupBeforePageLeave();
        __enablePopupBeforePageLeave = true;
      }
    }

    function specialGroupFuncs(action) {
      const selectLetters = [...document.querySelectorAll('.select-letter')];
      const fourthLetter = document.getElementById('ltrgen-greek-4');
      selectLetters.shift();
      
      if (action === 'hide') {
        hideLetter();
      } else if (action === 'show') {
        showLetter();
      }


      function hideLetter() {
        __isSpecialGroup = false;
        fourthLetter.classList.add('hide');
        selectLetters.forEach((letter) => letter.classList.remove('hide'));
      }

      function showLetter() {
        __isSpecialGroup = true;
        fourthLetter.classList.remove('hide');
        selectLetters.forEach((letter) => letter.classList.add('hide'));
      }
    }

    function replaceProductLabelsAboveGenerator(productStyles) {
        const prods = document.querySelectorAll('.switch-products > button');
        if (productStyles.length !== 2 || prods.length !== 2) return;

        handleLabels(productStyles[0], prods[0], false);
        handleLabels(productStyles[1], prods[1], productStyles[0] == productStyles[1]);

        function handleLabels(style, label, isDuplicate) {
          let result;
          const check = style.toLowerCase();
          
          switch (check) {
            case '2456':
              result = 'V-Neck';
              break;
            case 'g500':
              result = 'T-Shirt';
              break;
            case 'g200l':
              result = 'Ladies Tee';
              break;
            case '3633':
              result = 'Tank Top';
              break;
            case 'g120':
              result = '9oz. Crewneck';
              break;
            case 'g180':
              result = 'Crewneck';
              break;
            case 'g185':
              result = 'Hoodie';
              break;
            case 'g240':
              result = 'Long-Sleeve';
              break;
            case 's700':
              result = 'Champion® Hoodie';
              break;
            case '973':
              result = 'Sweatpants';
              break;
            default:
              result = '';
          }

          if (result !== '') {
            label.textContent += '(' + result + ')';
          }
        }
      }

    function boldUpdate(id, num, letter) {
      const apIndex = activeProduct === 2 ? 1 : 0;
      const __boldChangeEvent = new CustomEvent('change');

      if (id === 'letter') { 
        const lettered = (letter) => {
          if (letter === '*not applicable') {
            return '*Not Applicable'; 
          } else if (letter === `upsilon - ram's head`) {
            return "Upsilon - Ram's Head";
          } else if (letter === 'sigma alpha epsilon pi') {
            return "Sigma Alpha Epsilon Pi";
          } else if (letter === 'fiji letters') {
            return "FIJI Letters";
          }
          return letter.charAt(0).toUpperCase() + letter.slice(1);
        };

        const index = num - 1;
        const _letter = lettered(letter);

        try {
          bold.letter[index].value = _letter;
          bold.letter[index].dispatchEvent(__boldChangeEvent);
        } catch (err) {
          console.log(err);
        }

      } else if (id === 'pattern') {
        bold.pattern[apIndex].value = activePatternName;
        bold.pattern[apIndex].dispatchEvent(__boldChangeEvent);

      } else if (id === 'border') {
        bold.border[apIndex].value = activeBorderName;
        bold.border[apIndex].dispatchEvent(__boldChangeEvent);

      } else if (id === 'size') {
        bold.size[apIndex].value = activeSizeName;
        bold.size[apIndex].dispatchEvent(__boldChangeEvent);

      } else if (id === 'garment') {
        bold.garment[apIndex].value = activeGarmentName;
        bold.garment[apIndex].dispatchEvent(__boldChangeEvent);

        if (bold.garment[apIndex].value === '') {
          //console.log('got into if');
          bold.garment[activeProduct - 1].value = boldFindSimilarOption(activeGarmentName);
          bold.garment[activeProduct - 1].dispatchEvent(__boldChangeEvent);

          if (bold.garment[apIndex].value === '') {
            //alert(`${activeGarmentName} is out of stock or can't be found in dropdown.`);
            console.log(boldFindSimilarOption(activeGarmentName), activeGarmentName);
          }
        } else {
          //console.log('ddnt');
        }

      }
    }

    function boldFindSimilarOption(target) {
      const options = bold.garment[activeProduct - 1].querySelectorAll('.bold_option_element > select > option');

      for (const option of options) {
        const name = option.value;

        if ((name === 'Ash' && target === 'Ash Grey') || (name === 'Ash Grey' && target === 'Ash')) {
          return name;
        } else if ((name === 'Antique Cherry' && target === 'Antique Cherry Red') || (name === 'Antique Cherry Red' && target === 'Antique Cherry')) {
          return name;
        } else if ((name === 'Antique Jade' && target === 'Antique Jade Dome') || (name === 'Antique Jade Dome' && target === 'Antique Jade')) {
          return name;
        } else if ((name === 'Cardinal' && target === 'Cardinal Red') || (name === 'Cardinal Red' && target === 'Cardinal')) {
          return name;
        } else if ((name === 'Heather Sport Maroon' && target === 'Heather Sport Dark Maroon') || (name === 'Heather Sport Dark Maroon' && target === 'Heather Sport Maroon')) {
          return name;
        } else if ((name === 'Heather Sport Navy' && target === 'Heather Sport Dark Navy') || (name === 'Heather Sport Dark Navy' && target === 'Heather Sport Navy')) {
          return name;
        } else if ((name === 'Kelly' && target === 'Kelly Green') || (name === 'Kelly Green' && target === 'Kelly')) {
          return name;
        } else if ((name === 'Royal' && target === 'Royal Blue') || (name === 'Royal Blue' && target === 'Royal')) {
          return name;
        }

      }

      return null;
    }





    // Supplementary
    function slideLetters() {
      const toSlide = [document.querySelector('.letter-list'), document.querySelector('.letter-options')];
      toSlide.forEach((ele) => slideDropdown(ele));
    }

    function slideDropdown(ele) {
      const optionList = ele;
      optionList.classList.contains('options-dd__open') ? optionList.classList.remove('options-dd__open') : optionList.classList.add('options-dd__open');
    }

    function initPopupBeforePageLeave () {
       window.addEventListener("beforeunload", beforeunloadPopupFunc);
       document.getElementById('add-to-cart-btn').addEventListener('click', (e) => window.removeEventListener("beforeunload", beforeunloadPopupFunc));
       
       function beforeunloadPopupFunc(e) {
         e.returnValue = true;
       }
    }

    function updateSVG(num) {
      const update = (num) => {
        const svgTitle = document.querySelector(`#letter-title-${num}`);
        const svgDesc = document.querySelector(`#letter-desc-${num}`);
        const letter = document.querySelector(`#letter-${num}`).dataset.greek;
        const mainLetter = document.querySelector(`#ltrgen-greek-${num}`);

        svgTitle.innerHTML = `Letter ${num}: ${letter.toUpperCase().replace('FIJI_', '')}`;
        svgDesc.innerHTML = `${activePatternName ? activePatternName : 'No Pattern/Letter Color Selected'} || ${activeBorderName ? activeBorderName : 'No Border Color Selected'} || ${activeGarmentName ? activeGarmentName : 'No Garment Color Selected'}`;
        (letter === 'none') ? mainLetter.classList.add('js-no-letter') : mainLetter.classList.remove('js-no-letter');
        mainLetter.dataset.activeLetter = letter.toUpperCase();
      }

      if (typeof num !== 'undefined') {
        update(num);
      } else {
        const iterateTo = (!__isSpecialGroup) ? __defaultLetters.length : 4;
        for (let i = 0; i < iterateTo; i++) {
          update(i + 1);
        }
      }
    }





/* MAIN FUNCTION */
    const initOptions = async () => {
      // Front-end
      parseShopifyTag();
      boldSetup();

      // Data
      await prepareAPIData();
      renderOptions(1);
      renderOptions(2);
      renderOptions(3);
      __isPackage && renderOptions(3, __isPackage);
      !__isGroup && renderOptions(4);
      __isPackage && renderOptions(5);
      __isPackage && renderOptions(5, __isPackage);

      if (__isGroup == true && __isSigmaIotaAlpha == true) {
        const DOMElementForSigmaIotaAlphaLink = document.querySelector('[data-target="Pattern Sigma Iota Alpha (Red, Gold, Royal Blue)"]');
        if (!DOMElementForSigmaIotaAlphaLink) return;
        
        DOMElementForSigmaIotaAlphaLink.click();
      }
    };

    initOptions();

  });
} catch (err) {
  console.error('Letter Generator Failed', err);
}

